import '../css/screen.css';

import './screen/venue';
import './screen/price';
import './screen/dynamic-text-area';
import './screen/dynamic-links';
import './screen/gift-card';
import './screen/geo-location';